import i18next from "i18next";

let toastLife = 3000;
let timeout = 1000000;

class dbService {
  // constructor()
  // {
  // }



  //IMPORTANT: Change port here
  Server() {
    return window.location.hostname + ":9000";
    //return "localhost:9000";
  }
  /*const query = `UPDATE [CANNON_GDV].[dbo].[SETTINGS] SET [MIN] = ${minPressure}, [MAX] = ${maxPressure}, [STANBY] = ${stanbyPressure} WHERE [ID] = 1`;*/
  ExecModify(query, CompletionEvent) {
    const apiUrl = "Automata/ExecModify";

    const onComplete = (response) => {
      console.log("Request completed successfully:", response);
      CompletionEvent();
    };
    const onError = () => {
      console.error("Error occurred during the request.");
    };
    // Assuming you have an object for displaying toasts (adjust as needed)
    const objToast = {
      show: ({ severity, summary, detail, life }) => {
        console.log(
          `Toast: Severity-${severity}, Summary-${summary}, Detail-${detail}, Life-${life}`
        );
      },
    };
    const info = "Custom Info";
    const content = {
      query: query,
    };
    // Adjust the content type to "application/sql"
    dbservice.SendPostRequest(
      apiUrl,
      JSON.stringify(content),
      onComplete,
      onError,
      objToast,
      info
    );
  }

  //EXAMPLE
  /*`Automata/RouteName?param1=${param1Value}&param2=${param2Value}`,
    (resp) => {
      if (resp.data.length === 0) {
      } else {
         resp.data.res.map((resData) => {
            const {
              param1,
              param2,
            } = resData;
          });
        }
      }
    }*/
  SendGetRequest(apiUrl, onComplete, onError, objToast, info) {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", `http://${this.Server()}/${apiUrl}`, true); // async request
    xhr.onload = function (evt) {
      // Transfer Complete
      var response = JSON.parse(xhr.response);
      if (onComplete) onComplete(response);
    };
    xhr.onerror = function (evt) {
      // Transfer Failed
      if (objToast)
        objToast.show({
          severity:"error",
          summary: i18next.t("dberror"),
          detail: i18next.t("dberror1"),
          life:  toastLife,
        });
      if (onError) onError();
    };
    xhr.onabort = function (evt) {
      // Transfer Canceled
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail:  i18next.t("dberror2"),
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.ontimeout = function () {
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail:  i18next.t("dberror3"),
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.timeout = timeout;
    xhr.send();
  }

  //EXAMPLE
  /*dbservice.SendPostRequest(
        `Automata/RouteName?param1=${param1Value}&param2=${param2Value}`,
        "",
        (resp) => {
          if (resp.success === false) {
            console.log(resp);
          } else {
            return;
          }
        }
      );
      */

  SendPostRequest(apiUrl, content, onComplete, onError, objToast, info) {
    console.log("Sending POST request to:", `http://${this.Server()}/${apiUrl}`);
    let xhr = new XMLHttpRequest();
    xhr.open("POST", `http://${this.Server()}/${apiUrl}`, true); // async request
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function (evt) {
      // Transfer Complete
      if (xhr.status !== 200) {
        if (objToast)
          objToast.show({
            severity: "error",
            summary:i18next.t("dberror"),
            detail:  i18next.t("dberror1"),
            life: toastLife,
          });
        if (onError) onError();
      } else {
        var response = JSON.parse(xhr.response);
        if (onComplete) onComplete(response);
      }
    };
    xhr.onerror = function (evt) {
      // Transfer Failed
      if (objToast)
        objToast.show({
          severity: "error",
          summary: info ? info : "Errore",
          detail:  i18next.t("dberror1"),
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.onabort = function (evt) {
      // Transfer Canceled
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail:  i18next.t("dberror2"),
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.ontimeout = function () {
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail:  i18next.t("dberror3"),
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.timeout = timeout;
    xhr.send(content);
  }


  SendPatchRequest(apiUrl, content, onComplete, onError, objToast, info) {
    let xhr = new XMLHttpRequest();
    xhr.open("PATCH", `http://${this.Server()}/${apiUrl}`, true); // async request

    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function (evt) {
      // Transfer Complete
      if (xhr.status !== 200) {
        if (objToast)
          objToast.show({
            severity: "error",
            summary: i18next.t("dberror"),
            detail:  i18next.t("dberror1"),
            life: toastLife,
          });
        if (onError) onError();
      } else {
        var response = JSON.parse(xhr.response);
        if (onComplete) onComplete(response);
      }
    };
    xhr.onerror = function (evt) {
      // Transfer Failed
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail:  i18next.t("dberror1"),
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.onabort = function (evt) {
      // Transfer Canceled
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail:  i18next.t("dberror2"),
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.ontimeout = function () {
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail:  i18next.t("dberror3"),
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.timeout = timeout;
    xhr.send(content);
  }

  //EXAMPLE
  /*dbservice.SendDeleteRequest(
    `Automata/RouteName?param1=${param1Value}`,
    (resp) => {
      if (resp.success) {
      } else {
      }
    }
  );*/
  SendDeleteRequest(apiUrl, onComplete, onError, objToast, info) {
    let xhr = new XMLHttpRequest();
    xhr.open("DELETE", `http://${this.Server()}/${apiUrl}`, true); // async request
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onload = function (evt) {
      // Transfer Complete
      if (xhr.status !== 200) {
        if (objToast)
          objToast.show({
            severity: "error",
            summary: i18next.t("dberror"),
            detail: "Operazione non eseguita",
            life: toastLife,
          });
      } else {
        var response = JSON.parse(xhr.response);
        if (onComplete) onComplete(response);
      }
    };
    xhr.onerror = function (evt) {
      // Transfer Failed
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail: "Transfer Failed",
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.onabort = function (evt) {
      // Transfer Canceled
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail: "Transfer Canceled",
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.ontimeout = function () {
      if (objToast)
        objToast.show({
          severity: "error",
          summary: i18next.t("dberror"),
          detail: "Request timeout",
          life: toastLife,
        });
      if (onError) onError();
    };
    xhr.timeout = timeout;
    xhr.send();
  }
}

let dbservice = new dbService();
export default dbservice;
